export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./EmailResetPwd.vue?vue&type=template&id=3768810e&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/EmailResetPwd.vue?vue&type=template&id=3768810e&
// module id = null
// module chunks = 